import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { useCallback } from "react";
import { usePaymentForm } from "Payments/PaymentPage/PaymentFormScreen/PaymentFormContext";

export function useSetAuthToLoggedIn() {
  const { state } = usePaymentPage();
  const { dispatch: formDispatch } = usePaymentForm();
  const { isACHAllowed } = state.network;

  return useCallback(
    ({ authSkipped, hasPaymentMethod }) => {
      if (authSkipped) {
        formDispatch({
          type: "setFormStage",
          stage: "auth",
          value: "skipped",
        });
      } else {
        formDispatch({
          type: "setFormStage",
          stage: "auth",
          value: "isFullyLoggedIn",
        });
      }

      const paymentInfoValue = hasPaymentMethod
        ? "methodSelected"
        : isACHAllowed
        ? "chooseAddMethodType"
        : "addCard";

      formDispatch({
        type: "setFormStage",
        stage: "paymentInfo",
        value: paymentInfoValue,
      });
    },
    [formDispatch, isACHAllowed]
  );
}
